module.exports = __webpack_public_path__ + "static/img/paleterlayer.a8dcc1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/paleterlayer.png
// module id = 1h3m
// module chunks = 44